import React, { useEffect, useRef, useState } from 'react'
import CloseWindowIcon from '../../../assets/icons/delete.png'
import BlsGridTable from '../GridTable/BlsGridTable';
import { ValidationError } from "../../../assets/ErrorTypes";
import { getObjectDataWithPath, ConvertRegistryNameOrTitle } from "../../../assets/UtilMethods";
import { NumericFormat } from "react-number-format";
import Loader from "../Loader/Loader";

export const useBlsSearchInput = inputData => {
    const [_, __] = useState(inputData.value ?? "");
    const valueRef = useRef();
    const [label, setLabel] = useState(inputData.label ?? "labelAdı");
    const [placeHolder, setPlaceHolder] = useState(inputData.placeHolder ?? "");
    const [isLabelHidden, setIsLabelHidden] = useState(inputData.isLabelHidden ?? false);
    const [isHidden, setIsHidden] = useState(inputData.isHidden ?? false);
    const [disabled, setDisabled] = useState(inputData.disabled ?? false);
    const [selectedData, setSelectedData] = useState(inputData.selectedData ?? null);
    const [allowBlank, setAllowBlank] = useState(inputData.allowBlank ?? true);
    const checkRequired = () => {
        if (!allowBlank) {
            if (isNullOrEmpty()) {
                throw new ValidationError(`${label.replace(":", "")} alanı zorunludur`)
            }
        }
    }

    const value = valueRef.current?.value;
    const setValue = (text) => {
        if (valueRef.current) {
            valueRef.current.value = text;
        }
        __(text);

    }
    const clear = () => {
        if (valueRef.current) {
            valueRef.current.value = "";
        }
        __("");
        setSelectedData(null);
    }
    const isNullOrEmpty = () => {
        return (valueRef.current?.value === null || valueRef.current?.value === undefined || valueRef.current?.value === ""); // || selectedData === null
    }
    const hide = () => setIsHidden(true);
    const show = () => setIsHidden(false);

    const reset = () => {
        __(inputData.value ?? "");
        valueRef.current.value = "";
        setLabel(inputData.label ?? "labelAdı");
        setPlaceHolder(inputData.placeHolder ?? "");
        setIsLabelHidden(inputData.isLabelHidden ?? false);
        setIsHidden(inputData.isHidden ?? false);
        setDisabled(inputData.disabled ?? false);
        setSelectedData(inputData.selectedData ?? null);
        setAllowBlank(inputData.allowBlank ?? true);
    }

    return {
        valueRef,
        value, setValue,
        _, __,
        label, setLabel,
        isHidden, setIsHidden,
        isLabelHidden, setIsLabelHidden,
        disabled, setDisabled,
        placeHolder, setPlaceHolder,
        clear, isNullOrEmpty,
        selectedData, setSelectedData,
        allowBlank, setAllowBlank,
        checkRequired,
        hide, show,
        reset,
        isRegistry: inputData.isRegistry,
        searchQuery: inputData.searchQuery,
    }
}

const BlsSearchInput = ({ inputStyle, labelStyle, containerStyle, inputState, aggridStyle, aggridContainerStyle, columnDefs, type = 'text', labelAlign = 'left', uppercase = false, onChange = (any) => { }, onBlur = () => { }, service = async (any) => { }, handleSelectData = (any) => { }, onKeyPress = () => { }, noDelay = false, numericFormat = false, format = "" }) => {
    const [searchListVisibleStatus, setSearchListVisibleStatus] = useState(false)
    const [serviceData, setServiceData] = useState([])
    const [timer, setTimer] = useState(null)
    const [loading, setLoading] = useState(false)
    const aggridRef = useRef();
    const isValid = inputState.allowBlank ? true : !inputState.isNullOrEmpty();

    const defaultColDefinition = {
        editable: false,
        sortable: true,
        flex: 1,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
    }

    const handleTextChangeOfSearchService = (e) => {
        try {
            if (inputState.disabled) return;
            if (e.target.value.length >= 3 && !noDelay) {
                setSearchListVisibleStatus(true)
                clearTimeout(timer)

                const newTimer = setTimeout(async () => {
                    try {
                        setLoading(true)
                        let res = await service(e);
                        setServiceData(res)
                        setLoading(false)
                    } catch (e) {
                        setLoading(false);
                    }
                }, noDelay ? 0 : 500)

                setTimer(newTimer)
            } else if (noDelay) {
                setSearchListVisibleStatus(true)
                clearTimeout(timer)

                const newTimer = setTimeout(async () => {
                    setLoading(true)
                    let res = await service(e);
                    setServiceData(res)
                    setLoading(false)
                }, noDelay ? 0 : 500)

                setTimer(newTimer)
            } else {
                setServiceData([]);
                setLoading(false)
                setSearchListVisibleStatus(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    const selectData = e => {
        if (inputState.isRegistry) inputState.setValue(ConvertRegistryNameOrTitle(inputState.searchQuery ? getObjectDataWithPath(e.data, inputState.searchQuery) : e.data));
        else if (inputState.searchQuery) inputState.setValue(getObjectDataWithPath(e.data, inputState.searchQuery));

        handleSelectData(e.data)
        inputState.setSelectedData(e.data)
        setLoading(false)
        setSearchListVisibleStatus(false)
        setServiceData([])
    }

    useEffect(() => {
        if (searchListVisibleStatus) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [searchListVisibleStatus])

    const handleClickOutside = (event) => {
        if (aggridRef && !aggridRef.current?.contains(event.target)) {
            if (inputState.selectedData === null) {
                inputState.setValue('')
            } else {
                if (inputState.isRegistry) inputState.setValue(ConvertRegistryNameOrTitle(inputState.searchQuery ? getObjectDataWithPath(inputState.selectedData, inputState.searchQuery) : inputState.selectedData));
                else inputState.setValue(getObjectDataWithPath(inputState.selectedData, inputState.searchQuery));
            }
            ;
            setLoading(false)
            setSearchListVisibleStatus(false)
        }
    }

    return (
        <div style={{
            marginTop: '1%',
            borderWidth: 0,
            border: 'none',
            flexDirection: labelAlign === 'left' ? 'row' : 'column',
            display: inputState.isHidden ? 'none' : 'flex',
            ...containerStyle
        }}>
            <label style={{
                borderWidth: '1px',
                borderColor: '#f0f0f0',
                borderRadius: 3,
                width: labelAlign === 'left' ? '38%' : '100%',
                height: '20px',
                color: "#000",
                float: "left",
                paddingLeft: labelAlign === 'left' ? "2%" : "0%",
                textAlign: "left",
                backgroundColor: "transparent",
                overflow: "hidden",
                fontSize: '.73rem',
                display: inputState.isLabelHidden ? 'none' : 'block',
                ...labelStyle
            }}>{inputState.label}</label>

            <input
                ref={inputState.valueRef}
                defaultValue={inputState.value}
                placeholder={inputState.placeHolder}
                onBlur={(e) => {
                    inputState.__(e.target.value)

                    onBlur(e)
                }}
                onChange={e => {
                    if (uppercase) {
                        inputState.valueRef.current.value = e.target.value.toLocaleUpperCase('TR')
                    }

                    onChange(e);
                    handleTextChangeOfSearchService(e)
                }}
                onKeyPress={onKeyPress}
                /*onFocus={(e) => {
                    if (inputState.valueRef.current.value.length >= 3) {
                        handleTextChangeOfSearchService(e)
                    }
                }}*/
                readOnly={inputState.disabled}
                type={type}
                style={{
                    boxShadow: '1px 1px 5px #aeaeae',
                    borderColor: '#f0f0f0',
                    marginLeft: "0%",
                    height: '20px',
                    float: "left",
                    fontSize: '.73rem',
                    width: inputState.isLabelHidden ? '100%' : labelAlign === 'left' ? '50%' : '100%',
                    borderRadius: 3,
                    borderWidth: 1,
                    outline: inputState.disabled ? "inherit" : "inital",
                    textTransform: uppercase ? 'uppercase' : 'none',
                    cursor: inputState.disabled ? 'not-allowed' : 'text',
                    border: isValid ? 'none' : '1px solid red', //test
                    ...inputStyle
                }}
            />

            <Loader isLoading={loading} />

            <div ref={aggridRef} style={{ height: '250px', width: '800px', marginLeft: '10%', marginTop: '25px', borderColor: '#2471A3', borderWidth: 10, borderStyle: 'solid', boxShadow: '0 0 1vw 0 #000', borderRadius: '0.3vw', zIndex: 99, display: searchListVisibleStatus ? "block" : "none", position: 'absolute', ...aggridContainerStyle }}>
                <button style={{ backgroundColor: 'transparent', width: "24px", height: "24px", zIndex: 999, cursor: 'pointer', position: "absolute", marginLeft: "calc(100% - 18px)", marginTop: "-6px" }} onClick={() => setSearchListVisibleStatus(false)}>
                    <img src={CloseWindowIcon} width="24px" height="24px" alt="close" style={{ zIndex: 999 }} />
                </button>

                <div style={{ zIndex: 1, height: '100%' }}>
                    <BlsGridTable
                        containerStyle={{ height: '100%', marginTop: "0%", ...aggridStyle }}
                        columnDefs={columnDefs}
                        overlayNoRowsTemplate='<span style="padding: 10px; margin-top: 5%; border: 2px solid #444; background: white; border-radius:5">Veri bulunamadı</span>'
                        overlayLoadingTemplate='<span style="padding: 10px; margin-top: 5%; border: 2px solid #444; background: white; border-radius:5">Veriler yükleniyor. Lütfen bekleyin</span>'
                        rowData={serviceData}
                        defaultColDef={defaultColDefinition}
                        onRowDoubleClicked={selectData}
                    />
                </div>
            </div>
        </div>
    );
}

export default BlsSearchInput